import React from 'react';
import AssistantCard from './AssistantCard';
import SuggestionChips from './SuggestionChips';
import '../styles/MessageItem.css';
import botLogo from '../../../assets/SigerBotMsg.png';

const MessageItem = ({ message, onSuggestionClick, isLastAssistantMessage }) => {
  if (message.role === 'user') {
    return (
      <div className="message-item user-message-item">
        <div className="user-message-bubble">
          <p>{message.content}</p>
        </div>
      </div>
    );
  }

  // Assistant message
  return (
    <div className="message-item assistant-message-item">
      <div className="assistant-avatar-wrapper">
        <img 
          src={botLogo} 
          alt="SigerBot" 
          className="assistant-avatar"
          loading="lazy"
        />
      </div>
      <div className="assistant-message-bubble">
        <AssistantCard 
          message={message} 
          showActions={isLastAssistantMessage}
          onSuggestedAction={onSuggestionClick}
        />
        {/* {message.status === 'done' && isLastAssistantMessage && (
          <SuggestionChips onSuggestionClick={onSuggestionClick} />
        )} */}
      </div>
    </div>
  );
};

export default MessageItem;
